/* @flow */
import React from "react";
import * as Types from "./NextGenChartTypes";

const THICKNESS = 2;

function Bar(props: Types.RenderableCandle) {
  const openY = Math.floor(props.open[1]);
  const closeY = Math.floor(props.close[1]);

  const minimumY = Math.floor(props.minimum[1]);
  const maximumY = Math.floor(props.maximum[1]);

  const top = maximumY;
  const height = minimumY - maximumY || 1;

  const left = Math.floor(props.range[0]);
  const width = Math.floor(props.range[1]) - left;

  const padding = width / 8;

  return (
    <div
      style={{
        position: "absolute",
        width,
        height,
        WebkitTransform: `translateX(${left}px) translateY(${top}px)`,
        transform: `translateX(${left}px) translateY(${top}px)`
      }}
    >
      <div
        style={{
          width: THICKNESS,
          height: height + THICKNESS,
          background: props.close[2].value > props.open[2].value
            ? "#6cb032"
            : "#e74c3c",
          margin: "0 auto"
        }}
      />
      <div
        style={{
          position: "absolute",
          top: openY - maximumY,
          left: padding,
          width: width / 2 - padding,
          height: THICKNESS,
          background: props.close[2].value > props.open[2].value
            ? "#6cb032"
            : "#e74c3c"
        }}
      />
      <div
        style={{
          position: "absolute",
          top: closeY - maximumY,
          left: width / 2,
          width: width / 2 - padding,
          height: THICKNESS,
          background: props.close[2].value > props.open[2].value
            ? "#6cb032"
            : "#e74c3c"
        }}
      />
    </div>
  );
}

type Props = {
  candles: Array<Types.RenderableCandle>,
  viewportWidth: number
};

function BarChart(props: Props) {
  return props.candles
    .filter(
      candle => candle.close[0] > 0 && candle.open[0] < props.viewportWidth
    )
    .map(candle => <Bar key={candle.open[2].date} {...candle} />);
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/Chart/Bar.js